// Retrieve the current member from store or request it from the server
import store from "store"
import { computed, watch, ComputedRef, Ref } from "vue"
import { CurrentMember } from "suus-api"

export default function useCurrentMember() {
  const currentMemberRef: ComputedRef<CurrentMember> = computed(
    () => store.state.member.currentMember?.data
  )

  if (!currentMemberRef.value) {
    store.dispatch("member/getCurrentMember")
  }

  // A Promise that returns the current Member once loaded
  const currentMemberPromise = new Promise<Ref<CurrentMember>>((resolve) => {
    console.log("currentMemberPromise")
    if (currentMemberRef.value) {
      console.log("currentMemberRef.value", currentMemberRef.value)
      resolve(currentMemberRef)
    } else {
      console.log("currentMemberRef.value", currentMemberRef.value)
      const unsubscribe = watch(
        currentMemberRef,
        (value) => {
          console.log("currentMemberRef.value in watch", currentMemberRef.value)
          if (value) {
            unsubscribe()
            resolve(currentMemberRef)
          }
        },
        { immediate: true }
      )
    }
  })

  return {
    currentMemberPromise,
  }
}
